<template>
   <div>
      <div class="block-section-header block-header-label">
         <span>{{title}}</span>

         <b-switch
            v-if="exp_switch"
            v-model="on"
            type="is-success"
            @click="$emit('toggleShow')" :class="{expanded: isSwitched}"
         >{{isSwitched}}
         </b-switch>

         <div v-if="!exp_switch" class="btn-drop" @click="$emit('toggleShow')" :class="{expanded: expanded}"></div>
      </div>
   </div>
</template>

<script>
export default {
   data() {
      return {
         on: this.exp_on,
      }
   },

   props: [
      'title',
      'exp_switch',
      'exp_on',
      'expanded'
   ],

   computed: {
      isSwitched() {
         return this.exp_on ? 'On' : 'Off';
      }
   },

   watch: {
      on() {
         this.$parent.$emit('expChange', this.on);
      },

      exp_on() {
         this.on = this.exp_on;
      }
   }
}
</script>

<style lang="scss" scoped>
.block-section-header {
   border-bottom: 1px solid $bard-blue;
   padding: 10px 20px;
   background-color: $header-blue;
   text-transform: uppercase;
   display: flex;
   justify-content: flex-start;

   span {
      flex: 1;
   }
}

.block-header-label {
   text-transform: uppercase;
   letter-spacing: 2px;
   color: $gray-text;
   font-size: 14px;
}

.switch {
   display: flex;
   width: 70px;
   align-items: center;
   text-transform: initial;
   letter-spacing: initial;
   font-size: 14px;
   color: white;
}

.btn-drop {
   padding: 0;
   border: 0;
   background-color: transparent;
   color: white;
   font-size: 14px;
   border-radius: 0px;

   &:hover {
      background-color: transparent;
      cursor: pointer;
      border: none;
      outline: none;
   }
   
   &:after {
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-left: 24px;
      content: '';
      border: 0;
      background-image: url(../assets/img/instances/SVGs/arrow-right.svg);
      background-repeat: no-repeat;
      background-size: 10px 10px;
   }

   &.expanded:after {
      background-image: url('../assets/img/instances/SVGs/arrow-down.svg');
   }
}

// Media Library Dashboard 
.dashboard-top-row {
   .block-header-label {
      font-size: 16px;
      color: white;
   }
}

// Manage Dashboard 
#manage-dashboard {
   .dashboard-bottom-row {
      .block-header-label {
         border: 1px solid rgba(255, 255, 255, $alpha6);
      }
   }
}

</style>

